import { add } from "date-fns";

export const expirationTime = () => {
  const currentDate = new Date();
  const expirationDate = add(currentDate, { days: 30 });

  return expirationDate.toUTCString();
};
